







































































































































































































































































import { Vue, Component, Watch } from "vue-property-decorator";
import { isRoot } from "@/plugins/roles";
import course, { CourseListParams } from "@/getinfo-api/course";
import { CoursesList as ICoursesList } from "@/api/models/courses-list";
import { Course as ICourse } from "@/api/models/course";
import { getCurrentUserId } from "@/plugins/roles";
import CourseListItemTables from "@/components/courses/CourseListItemTables.vue";
import { ResourceCategory as IResourceCategory } from "@/api/models/resource-category";
import { uniqBy } from "lodash";
import { Employee as IEmployee } from "@/api/models/employee";
import { EmployeesList2 as IEmployeesList2 } from "@/api/models/employees-list2";
import employee, { EmployeeListParams } from "@/getinfo-api/employee";
import api from "@/getinfo-api";
import CPage from "@/components/form/CustomPage/CPage.vue";
import CField from "@/components/form/CField.vue";
import CBlock from "@/components/form/CustomPage/CBlock.vue";
import CustomTable from "@/components/form/CustomTable.vue";
import CustomButton from "@/components/form/CustomButton.vue";
import CSingleSelect from "@/components/form/CSingleSelect.vue";
import CourseV2List from "@/components/courses/CourseV2/CourseV2List.vue";
import { scormModule } from "@/plugins/modules-detect";
import { LearningMaterialLocales } from "@/plugins/custom-interface";

@Component({
  components: {
    CourseV2List,
    CSingleSelect,
    CustomButton,
    CustomTable,
    CBlock,
    CField,
    CPage,
    CourseListItemTables
  }
})
export default class CourseListView extends Vue {
  categoryList!: IResourceCategory;
  courses: Array<ICourse> = [];
  courseCount!: number | undefined;
  companyCourses: Array<ICourse> = [];
  companyCourseCount!: number | undefined;
  searchTitle!: string | undefined;
  categoryId!: string | undefined;
  limit: number = 30;
  offset: number = 0;
  showSpinner: boolean = false;
  ownerId: string | undefined;
  employees: Array<IEmployee> | undefined = [];
  enabled: boolean | undefined = true;
  sortedBy: any = "createdAt";
  order?: "ASC" | "DESC" = "DESC";
  locale: string | undefined = "";

  data() {
    return {
      categoryList: undefined,
      courseCount: undefined,
      companyCourseCount: undefined,
      searchTitle: undefined,
      categoryId: undefined,
      ownerId: undefined
    };
  }

  get isScormModule() {
    return scormModule();
  }

  get isShowAddIcon() {
    return (
      this.root ||
      this.contentManager ||
      this.companyOwner ||
      !this.$store.state.user.user.isOnlyContractor
    );
  }

  get showActions() {
    return this.root || this.companyOwner || this.contentManager;
  }

  get iconClass() {
    return this.order === "DESC"
      ? "fas fa-long-arrow-alt-down"
      : "fas fa-long-arrow-alt-up";
  }

  get locales() {
    return LearningMaterialLocales();
  }

  get selectedCompanyId() {
    return this.$store.getters?.selectedCompany?.id;
  }

  get screenWidth() {
    return window.innerWidth;
  }

  get root() {
    return isRoot();
  }

  get userId() {
    return getCurrentUserId();
  }

  get companyOwner() {
    return this.$store.getters.userIsCompanyOwner;
  }

  get contentManager() {
    return this.$store.getters.roles.includes("content_manager");
  }

  get learningRequestManager() {
    return this.$store.getters.roles.includes("learning_request_manager");
  }

  // get checkAccessColumns() {
  //   return this.selectedCompanyId && this.learningRequestManager;
  // }

  sortCourseCompany(sortType: any) {
    if (this.sortedBy === sortType) {
      this.order = this.order === "DESC" ? "ASC" : "DESC";
    } else {
      this.order = "DESC";
    }
    this.sortedBy = sortType;
    this.companyCourses = [];
    this.getCompanyCourses(0);
  }

  sortCourse(sortType: any) {
    if (this.sortedBy === sortType) {
      this.order = this.order === "DESC" ? "ASC" : "DESC";
    } else {
      this.order = "DESC";
    }
    this.sortedBy = sortType;
    this.courses = [];
    this.getCourses(0);
  }

  showMore() {
    this.offset += this.limit;
    this.getCourses(this.offset);
  }

  showMoreCompanyCourses() {
    this.offset += this.limit;
    this.getCompanyCourses(this.offset);
  }

  changeOffsetByWebinarsListMode(mode: "listener" | "employee") {
    const getOffset = (array: Array<ICourse>) => {
      const length = array.length;

      return length < this.limit ? 0 : length - this.limit;
    };

    this.offset =
      mode === "listener"
        ? getOffset(this.courses)
        : getOffset(this.companyCourses);
  }

  getEmployee() {
    if (this.root || this.companyOwner) {
      let params: EmployeeListParams = {
        id: this.selectedCompanyId,
        roles: ["content_manager"],
        limit: 300
      };

      employee(params).then((res: { data: IEmployeesList2 }) => {
        this.employees = res.data.employees;
      });
    }
  }

  applyFilter() {
    this.offset = 0;
    this.courses = [];
    this.companyCourses = [];
    this.companyCourseCount = undefined;
    this.courseCount = undefined;
    this.showSpinner = true;
    if (this.selectedCompanyId) {
      this.getCourses(this.offset);
      this.getCompanyCourses(this.offset);
    } else {
      this.getCourses(this.offset);
    }
  }

  getCompanyCourses(offset: number = 0) {
    this.showSpinner = true;
    if (this.selectedCompanyId) {
      if (this.companyOwner || this.root) {
        let params: CourseListParams = {
          title: this.searchTitle ? this.searchTitle : undefined,
          categoryIds: this.categoryId ? [this.categoryId] : undefined,
          companyIds: [this.selectedCompanyId],
          limit: this.limit,
          sort: this.sortedBy,
          order: this.order,
          locale: this.locale,
          ownerIds: this.ownerId ? [this.ownerId] : undefined,
          offset: offset,
          mode: "v2",
          enabled: this.enabled
        };

        course(params).then((res: { data: ICoursesList }) => {
          this.companyCourseCount = res.data.count;
          res.data.courses.forEach(course => {
            this.companyCourses.push(course);
          });
          this.showSpinner = false;
          this.companyCourses = uniqBy(this.companyCourses, "id");
        });
      } else {
        let params: CourseListParams = {
          title: this.searchTitle ? this.searchTitle : undefined,
          categoryIds: this.categoryId ? [this.categoryId] : undefined,
          companyIds: [this.selectedCompanyId],
          ownerIds: [this.userId],
          sort: this.sortedBy,
          order: this.order,
          limit: this.limit,
          locale: this.locale,
          offset: offset,
          mode: "v2",
          enabled: this.enabled
        };

        course(params)
          .then(res => {
            this.companyCourseCount = res.data.count;
            res.data.courses.forEach(course => {
              this.companyCourses.push(course);
            });
            this.companyCourses = uniqBy(this.companyCourses, "id");
          })
          .finally(() => {
            this.showSpinner = false;
          });
      }
    }
  }

  getCourses(offset: number = 0) {
    this.showSpinner = true;
    if (this.root) {
      let params: CourseListParams = {
        title: this.searchTitle ? this.searchTitle : undefined,
        categoryIds: this.categoryId ? [this.categoryId] : undefined,
        limit: this.limit,
        sort: this.sortedBy,
        order: this.order,
        locale: this.locale,
        mode: "v2",
        offset: offset
      };

      course(params)
        .then((res: { data: ICoursesList }) => {
          this.courseCount = res.data.count;
          res.data.courses.forEach(course => {
            this.courses.push(course);
          });
          this.courses = uniqBy(this.courses, "id");
        })
        .finally(() => {
          this.showSpinner = false;
        });
    } else {
      let paramsForListener: CourseListParams = {
        title: this.searchTitle ? this.searchTitle : undefined,
        categoryIds: this.categoryId ? [this.categoryId] : undefined,
        listenerUserIds: [this.userId],
        sort: this.sortedBy,
        order: this.order,
        limit: this.limit,
        locale: this.locale,
        mode: "v2",
        enabled: true,
        offset: offset
      };

      course(paramsForListener)
        .then((res: { data: ICoursesList }) => {
          this.courseCount = res.data.count;
          res.data.courses.forEach(course => {
            this.courses.push(course);
          });
          this.courses = uniqBy(this.courses, "id");
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  getCourseCategories() {
    if (this.selectedCompanyId) {
      api.CourseApi.categories(undefined, [this.selectedCompanyId]).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    } else {
      //@ts-ignore
      api.CourseApi.categories(this.userId, undefined).then(
        (res: { data: IResourceCategory }) => {
          this.categoryList = res.data;
        }
      );
    }
  }

  @Watch("contentManager")
  updateCoursesByContentManager() {
    this.updatedInfo();
  }

  @Watch("selectedCompanyId")
  updateCourses() {
    this.updatedInfo();
  }

  updatedInfo() {
    this.offset = 0;
    this.courses = [];
    this.companyCourses = [];
    this.companyCourseCount = undefined;
    this.courseCount = undefined;
    this.searchTitle = undefined;
    this.categoryId = undefined;
    this.locale = undefined;
    this.showSpinner = true;
    this.ownerId = this.root || this.companyOwner ? undefined : this.ownerId;
    this.enabled =
      this.root || this.companyOwner || this.contentManager ? undefined : true;
    this.getCourses();
    this.getCompanyCourses();
    this.getEmployee();
    this.getCourseCategories();
  }

  mounted() {

    // console.log(this.showActions);
    // console.log(this.root);
    // console.log(this.learningRequestManager);
    // console.log(this.companyOwner);
    // console.log(this.contentManager);

    this.showSpinner = true;
    if (this.selectedCompanyId) {
      this.getCourses();
      this.getCompanyCourses();
      this.getCourseCategories();
      this.getEmployee();
    } else {
      this.getCourses();
    }
  }
}
